import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultantRoutingModule } from './consultant-routing.module';
import { ListConsultantComponent } from './components/list-consultant/list-consultant.component';
import { IntercontratComponent } from './components/intercontrat/intercontrat.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { SuggestionJobOfferComponent } from './components/suggestion-job-offer/suggestion-job-offer.component';
import { SuggestionJobRequestComponent } from './components/suggestion-job-request/suggestion-job-request.component';
import { ListconsultantclientComponent } from './components/listconsultantclient/listconsultantclient.component';
import {SharedModule} from 'app/shared/shared.module'
import { CalendarModule } from 'primeng/calendar';
import { MatMenuModule } from '@angular/material/menu';
import { AddConsultantComponent } from './add-consultant/add-consultant.component';
import { UpdateConsultantComponent } from './update-consultant/update-consultant.component';
@NgModule({
  declarations: [
    ListConsultantComponent,
    IntercontratComponent,
    SuggestionJobOfferComponent,
    SuggestionJobRequestComponent,
    ListconsultantclientComponent,
    AddConsultantComponent,
    UpdateConsultantComponent,
  ],
  imports: [
    CommonModule,
    ConsultantRoutingModule,
    NgSelectModule,
    NgxSpinnerModule,
    PaginationModule,
    ReactiveFormsModule,
    FieldErrorModule,
    SharedModule,
    CalendarModule,
    MatMenuModule
  ],
})
export class ConsultantModule {}
